// Bloom World store — family, active child, and per-child living gardens.
// Rewards are generic "living elements" (kind registry) so flowers can later
// become butterflies, birds and trees without any schema change.

const ACTIVE_KEY = "bloom-active-child";
const gardenKey = (childId) => `bloom-world-v1-${childId}`;

export const CHILDREN = [
  { id: "aarav", name: "Aarav", year: 1, avatar: 0 },
  { id: "sophia", name: "Sophia", year: 2, avatar: 1 },
  { id: "ethan", name: "Ethan", year: 3, avatar: 2 },
  { id: "amelia", name: "Amelia", year: 4, avatar: 3 },
  { id: "noah", name: "Noah", year: 5, avatar: 4 },
  { id: "olivia", name: "Olivia", year: 6, avatar: 5 },
];

export function getActiveChild() {
  try {
    const id = localStorage.getItem(ACTIVE_KEY);
    return CHILDREN.find((c) => c.id === id) || null;
  } catch (e) {
    return null;
  }
}

export function setActiveChild(id) {
  try {
    localStorage.setItem(ACTIVE_KEY, id);
  } catch (e) {
    /* no-op */
  }
}

// Route year is the source of truth; the active child is used when they match.
export function getChildForYear(year) {
  const active = getActiveChild();
  if (active && active.year === year) return active;
  return CHILDREN.find((c) => c.year === year);
}

const seed = () => ({
  elements: [
    { id: "welcome-1", kind: "flower", from: "welcome", label: "This flower bloomed the day you joined!", earnedAt: new Date().toISOString() },
    { id: "welcome-2", kind: "flower", from: "welcome-2", label: "Bloom planted this one just for you.", earnedAt: new Date().toISOString() },
  ],
});

export function getWorld(childId) {
  const key = gardenKey(childId);
  try {
    const raw = localStorage.getItem(key);
    if (raw) {
      const w = JSON.parse(raw);
      if (w && Array.isArray(w.elements)) return w;
    }
  } catch (e) {
    /* no-op */
  }
  const w = seed();
  try {
    localStorage.setItem(key, JSON.stringify(w));
  } catch (e) {
    /* no-op */
  }
  return w;
}

// One living element per source per day — replay never spams the garden.
export function plantElement({ kind = "flower", from, label }) {
  const childId = (getActiveChild() || CHILDREN[0]).id;
  const w = getWorld(childId);
  const day = new Date().toISOString().slice(0, 10);
  const id = `${from}-${day}`;
  if (w.elements.some((e) => e.id === id)) return w;
  w.elements.push({ id, kind, from, label, earnedAt: new Date().toISOString() });
  try {
    localStorage.setItem(gardenKey(childId), JSON.stringify(w));
  } catch (e) {
    /* no-op */
  }
  return w;
}

export function getTimeOfDay(d = new Date()) {
  const h = d.getHours();
  if (h >= 5 && h < 12) return { period: "morning", greeting: "Good morning" };
  if (h >= 12 && h < 17) return { period: "afternoon", greeting: "Good afternoon" };
  return { period: "evening", greeting: "Good evening" };
}
